import { createReducer, on } from "@ngrx/store";
import authActions from "@state/auth/actions";
import { LoadingState } from "@state/models";
import actions from "./actions";
import { FeatureState } from "./models";

const initialState: FeatureState = {
  items: {},
  state: LoadingState.init,
  error: null
};

export const featureReducer = createReducer(
  initialState,
  on(actions.featuresLoading, (state) => ({ ...state, state: LoadingState.loading, error: null })),
  on(actions.featuresLoaded, (state, action) => ({ ...state, items: action.features, state: LoadingState.loaded, error: null })),
  on(actions.reset, () => ({ ...initialState })),
  on(actions.error, (state, action) => ({ ...state, state: LoadingState.error, error: action.error })),
  on(authActions.signedOut, () => ({ ...initialState }))
);
